
<template>
  <div>
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      max-width="800px"
      transition="dialog-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn small color="primary" dark v-bind="attrs" v-on="on"><v-icon left>mdi-pencil</v-icon>Editar</v-btn>
      </template>

      <v-card style="border-radius: 5px" v-if="dialog">
        <v-card-title primary-title>
          <div class="headline mb-0">Editando Informações Básicas</div>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form ref="form1">
            <main-data class="mt-5" :main_data="main_data"></main-data>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-end">
          <v-btn text color="error" @click="cancelChanges">Cancelar</v-btn>
          <v-btn text color="success" @click="saveInfo">salvar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import MainData from '@/components/user/register/new/MainData'
import http from '@/plugins/axios'

export default {
  name: 'DialogEditMainData',
  components: {
    MainData,
  },
  data() {
    return {
      dialog: false,
      main_data: {},
    }
  },
  mounted () {
    this.setupLocalMainData()
  },
  methods: {
    setupLocalMainData(){
      let {id, name, email, rule_ids,} = this.one_user
      this.main_data = {id, name, email, rule_ids}
    },
    cancelChanges() {
      this.setupLocalMainData()
      this.dialog = false
    },

    saveInfo() {
      const validate = this.$refs.form1.validate()
      if (validate) {
        this.$swal({
          showConfirmButton: true,
          showCancelButton: true,
          cancelButtonText: 'Cancelar',
          title: `Deseja salvar as modificações?`,
          icon: 'question',
        }).then(r=>{
          if (r.isConfirmed) {
            this.saveUser()
          }
        })
      }
    },
    saveUser(){
      let {...vid} = this.main_data
      
      this.saveMainData({data: {...vid, id: this.$route.params.id}}).then(async (v) => {
        this.e6 = 1
        this.dialog= false
        this.$router.push({name: 'Users'})
      }).catch(err => {
        console.log(err)
      })
    },

    ...mapActions({
      saveMainData: 'User/update',
    })
  },
  computed: {
    ...mapState({
      one_user: state => state.User.oneUser
    }),
  },
  watch: {
  },
}
</script>

<style scoped>

</style>
